import { MutationTree } from "vuex";
import { DocumentConstructor } from "@/types";
import { IDataProvider } from "@/store";
import { IDocumentConstructorState } from "@/store/modules/documentConstructor/state";

export enum DocumentConstructorMutations {
  SET_ONE = "SET_ONE_DOCUMENT_CONSTRUCTOR",
  SET_ALL = "SET_ALL_DOCUMENT_CONSTRUCTOR",
  SET_LAZY_DATA = "SET_LAZY_DATA_DOCUMENT_CONSTRUCTOR",
}

export const mutations: MutationTree<IDocumentConstructorState> = {
  [DocumentConstructorMutations.SET_ONE](state, payload: DocumentConstructor) {
    state.documentConstructor = payload;
  },
  [DocumentConstructorMutations.SET_ALL](
    state,
    payload: DocumentConstructor[]
  ) {
    state.documentConstructors = payload;
  },
  [DocumentConstructorMutations.SET_LAZY_DATA](
    state,
    payload: IDataProvider<DocumentConstructor>
  ) {
    state.dataProvider = payload;
  },
};
